import ClearableInput from 'components/common/ClearableInput/ClearableInput';
import ELEMENT from 'common/element';

export type LogDetailsFilterProps = {
  fieldFilter: string;
  setFieldFilter: (filter: string) => void;
  placeholder?: string;
};

/**
 * This component provides an input that can be used to filter which fields are shown in log details.
 *
 * @prop fieldFilter    current value of filter
 * @prop setFieldFilter function to set value of filter
 */
function LogDetailsFilter({
  fieldFilter,
  setFieldFilter,
  placeholder = 'Filter fields',
}: LogDetailsFilterProps): JSX.Element {
  // input where user can filter which fields are shown
  return (
    <ClearableInput
      placeholder={placeholder}
      size="sm"
      value={fieldFilter}
      onChange={(filter: string): void => setFieldFilter(filter)}
      testId={ELEMENT.searchSidebarFacetFilter}
      className="col-lg-12"
    />
  );
}

export default LogDetailsFilter;
